import {ajax,getRequestUrl,formatData} from "../request";

export default {
  // 数据统计 -- 分页数据
  getDataListByPage(data, method) {
    return ajax('post', getRequestUrl('/data/rechargeData'), data, {
      method,
    });
  },

  // 平台运营数据 -- 退款明细
  refundDetailsListData(data, method) {
    return ajax('post', getRequestUrl('/api/Data/refundDetailsList'), data, {
      method,
    })
  },

  // 平台运营数据 -- 冻结明细
  freezeDetailsList(data, method) {
    return ajax('post', getRequestUrl('/api/Data/freezeDetailsList'), data, {
      method,
    })
  },

  // 平台统计 -- 活跃房间日/周统计
  activeRoomDayOrWeek(data, method) {
    return ajax('post', getRequestUrl('/api/Data/activeRoomDayOrWeek'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 水果机用户分析
  fruitGameUserAnalysis(data, method) {
    return ajax('post', getRequestUrl('/data/fruit/userAnalysis'), data, {
      method,
    });
  },

  // 水果机对局总数
  fruitGameTotal(data, method) {
    return ajax('post', getRequestUrl('/data/fruit/roundAnalysis'), data, {
      method,
    });
  },

  // 水果机日排行
  fruitGameRank(data, method) {
    return ajax('post', getRequestUrl('/data/fruit/userDailyRank'), data, {
      method,
    });
  },

  // 水果机每日对局
  fruitGameDay(data, method) {
    return ajax('post', getRequestUrl('/data/fruit/roundRecord'), data, {
      method,
    });
  },

  // 水果机对局详情
  fruitGameRoundDetail(data, method) {
    return ajax('post', getRequestUrl('/data/fruit/roundDetail'), data, {
      method,
    });
  },

  // 大R充值追踪
  bigRechargeListNew(data, method) {
    return ajax('post', getRequestUrl('/api/Data/bigRechargeListNew'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 礼物互动统计
  giftInteractionList(data, method) {
    return ajax('post', getRequestUrl('/api/Data/giftInteractionList'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // 所有地区充值统计
  getRechargeLogData(data, method) {
    return ajax('post', getRequestUrl('/api/Data/getRechargeLogData'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // foodie 用户分析
  foodieGameUserAnalysis(data, method) {
    return ajax('post', getRequestUrl('/data/foodie/userAnalysis'), data, {
      method,
    });
  },

  foodieGameTotal(data, method) {
    return ajax('post', getRequestUrl('/data/foodie/roundAnalysis'), data, {
      method,
    });
  },

  foodieGameRank(data, method) {
    return ajax('post', getRequestUrl('/data/foodie/userDailyRank'), data, {
      method,
    });
  },

  foodieGameDay(data, method) {
    return ajax('post', getRequestUrl('/data/foodie/roundRecord'), data, {
      method,
    });
  },

  foodieGameRoundDetail(data, method) {
    return ajax('post', getRequestUrl('/data/foodie/roundDetail'), data, {
      method,
    });
  },


  // greedyCat 用户分析
  greedyCatGameUserAnalysis(data, method) {
    return ajax('post', getRequestUrl('/data/greedy/userAnalysis'), data, {
      method,
    });
  },

  greedyCatGameTotal(data, method) {
    return ajax('post', getRequestUrl('/data/greedy/roundAnalysis'), data, {
      method,
    });
  },

  greedyCatGameRank(data, method) {
    return ajax('post', getRequestUrl('/data/greedy/userDailyRank'), data, {
      method,
    });
  },

  greedyCatGameDay(data, method) {
    return ajax('post', getRequestUrl('/data/greedy/roundRecord'), data, {
      method,
    });
  },

  greedyCatGameRoundDetail(data, method) {
    return ajax('post', getRequestUrl('/data/greedy/roundDetail'), data, {
      method,
    });
  },



  // slots
  slotsBigboardList(data, method) {
    return ajax('post', getRequestUrl('/data/slots/bigBoard'), data, {
      method,
    });
  },

  slotsDailyStatList(data, method) {
    return ajax('post', getRequestUrl('/data/slots/dailyDetail'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  slotsPlayerDetail(data, method) {
    return ajax('post', getRequestUrl('/data/slots/userDetail'), data, {
      method,
    });
  },

  slotsRoundList(data, method) {
    return ajax('post', getRequestUrl('/data/slots/roundDetail'), data, {
      method,
    });
  },

  // lucky77
  lucky7BigboardList(data, method) {
    return ajax('post', getRequestUrl('/data/lucky7/bigBoard'), data, {
      method,
    });
  },

  lucky7DailyStatList(data, method) {
    return ajax('post', getRequestUrl('/data/lucky7/dailyDetail'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  lucky7PlayerDetail(data, method) {
    return ajax('post', getRequestUrl('/data/lucky7/userDetail'), data, {
      method,
    });
  },

  lucky7RoundList(data, method) {
    return ajax('post', getRequestUrl('/data/lucky7/roundDetail'), data, {
      method,
    });
  },

  // candy crush
  candyCrushList(data, method) {
    return ajax('post', getRequestUrl('/data/candy/bigBoard'), data, {
      method,
    });
  },

  candyCrushDailyList(data, method) {
    return ajax('post', getRequestUrl('/data/candy/dailyDetail'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  candyCrushDetail(data, method) {
    return ajax('post', getRequestUrl('/data/candy/userDetail'), data, {
      method,
    });
  },

  candyCrushRoundList(data, method) {
    return ajax('post', getRequestUrl('/data/candy/roundDetail'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // fruit77
  fruit7List(data, method) {
    return ajax('post', getRequestUrl('/data/fruit7/bigBoard'), data, {
      method,
    });
  },

  fruit7DailyList(data, method) {
    return ajax('post', getRequestUrl('/data/fruit7/dailyDetail'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  fruit7Detail(data, method) {
    return ajax('post', getRequestUrl('/data/fruit7/userDetail'), data, {
      method,
    });
  },

  fruit7RoundList(data, method) {
    return ajax('post', getRequestUrl('/data/fruit7/roundDetail'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  // magic sphinx
  magicSphinxBigboardList(data, method) {
    return ajax('post', getRequestUrl('/data/sphinx/bigBoard'), data, {
      method,
    });
  },

  magicSphinxDailyStatList(data, method) {
    return ajax('post', getRequestUrl('/data/sphinx/dailyDetail'), data, {
      method,
    }).then(data => {
      return formatData.formatListData(data);
    });
  },

  magicSphinxPlayerDetail(data, method) {
    return ajax('post', getRequestUrl('/data/sphinx/userDetail'), data, {
      method,
    });
  },

  magicSphinxRoundList(data, method) {
    return ajax('post', getRequestUrl('/data/sphinx/roundDetail'), data, {
      method,
    });
  },

  // greedy
  greedyBigboardList(data, method) {
    return ajax('post', getRequestUrl('/api/Game/greedyBigboardList'), data, {
      method,
    })
  },

  greedyDailyStatList(data, method) {
    return ajax('post', getRequestUrl('/api/Game/greedyDailyStatList'), data, {
      method,
    })
  },

  greedyPlayerDetailList(data, method) {
    return ajax('post', getRequestUrl('/api/Game/greedyPlayerDetailList'), data, {
      method,
    })
  },

  greedyPlayerList(data, method) {
    return ajax('post', getRequestUrl('/api/Game/greedyPlayerList'), data, {
      method,
    })
  },

  // dashboards
  globalDataDashboard(data, method) {
    return ajax('post', getRequestUrl('/api/Data/globalDataDashboard'), data, {
      method,
    })
  },

  topDataDashboard(data, method) {
    return ajax('post', getRequestUrl('/api/Data/topDataDashboard'), data, {
      method,
    })
  },

  UserDataDashboard(data, method) {
    return ajax('post', getRequestUrl('/api/Data/UserDataDashboard'), data, {
      method,
    })
  },

  sudDaily(data, method) {
    return ajax('post', getRequestUrl('/data/sud/daily'), data, {
      method,
    })
  },

  sudGameDetail(data, method) {
    return ajax('post', getRequestUrl('/data/sud/gameDetail'), data, {
      method,
    })
  },

  // room party
  roomPartyList(data, method) {
    return ajax('post', getRequestUrl('/room/roomParty/list'), data, {
      method,
    })
  },

  roomPartyRank(data, method) {
    return ajax('post', getRequestUrl('/room/roomParty/rank'), data, {
      method,
    })
  },
  roomPartyDel(data, method) {
    return ajax('post', getRequestUrl('/room/roomParty/del'), data, {
      method,
    })
  },
  roomPartyUpdate(data, method) {
    return ajax('post', getRequestUrl('/room/roomParty/update'), data, {
      method,
    })
  },

  // big R lists
  bigRnewR(data, method) {
    return ajax('post', getRequestUrl('/data/rechargeData/bigR/newR'), data, {
      method,
    })
  },

  bigRInteractive(data, method) {
    return ajax('post', getRequestUrl('/data/rechargeData/bigR/Interactive'), data, {
      method,
    })
  },

  // 金币发放统计
   getPayLogData(data, method) {
    return ajax('post', getRequestUrl('/data/getPayLogData'), data, {
      method,
    })
  },

  // 用户幸运游戏补充系统
  luckyGameDataList(data, method) {
    return ajax('post', getRequestUrl('/data/sud/compensate'), data, {
      method,
    })
  },
  getRechargeSelectList(data, method) {
    return ajax('post', getRequestUrl('/assets/rechargeSelectList'), data, {
      method,
    })
  },
  // 检查周期内是否已补偿
  checkIsCompensate(data, method) {
    return ajax('post', getRequestUrl('/data/compensate/check'), data, {
      method,
    })
  },
  // 补偿记录
  compensateDetail(data, method) {
    return ajax('post', getRequestUrl('/data/compensate/record'), data, {
      method,
    })
  },
  // 修改补偿备注
  updateCompensateRemark(data, method) {
    return ajax('post', getRequestUrl('/data/compensate/updateRemark'), data, {
      method,
    })
  },

  // 用户日充值记录
  userDailyRechargeRecord(data, method) {
    return ajax('post', getRequestUrl('/user/recharge/dailyRecord'), data, {
      method,
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/https/data.js